import React from "react";
import { Group, Image as KImage } from "react-konva";
import useImage from "use-image";

export default function AvatarPreview({ circ, url }) {
  const [img] = useImage(url || "", "anonymous");
  if (!img || !circ) return null;

  const x = circ.cx - circ.d / 2;
  const y = circ.cy - circ.d / 2;
  const d = circ.d;

  return (
    <Group
      x={x}
      y={y}
      listening={false}
      clipFunc={(ctx) => {
        ctx.beginPath();
        ctx.arc(d / 2, d / 2, d / 2, 0, Math.PI * 2);
        ctx.closePath();
      }}
    >
      <KImage image={img} width={d} height={d} listening={false} />
    </Group>
  );
}
